import React, { useContext, useState } from 'react';
import useOnclickOutside from 'react-cool-onclickoutside';
import ReactCountryFlag from 'react-country-flag';
import { useIntl } from 'gatsby-plugin-intl';

import LanguageContext from '../../contexts/LanguageContext';

export const German = () => (
  <>
    <ReactCountryFlag countryCode="DE" svg className="mr-1 block" />
    <span>Deutsch</span>
  </>
);
export const English = () => (
  <>
    <ReactCountryFlag countryCode="GB" svg className="mr-1 block" />
    <span>English</span>
  </>
);
export const French = () => (
  <>
    <ReactCountryFlag countryCode="FR" svg className="mr-1 block" />
    <span>Français</span>
  </>
);
export const Danish = () => (
  <>
    <ReactCountryFlag countryCode="DK" svg className="mr-1 block" />
    <span>Dansk</span>
  </>
);
export const Norwegian = () => (
  <>
    <ReactCountryFlag countryCode="NO" svg className="mr-1 block" />
    <span>Norsk</span>
  </>
);
export const Dutch = () => (
  <>
    <ReactCountryFlag countryCode="NL" svg className="mr-1 block" />
    <span>Nederlands</span>
  </>
);

export const LanguageSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { changeLanguage, changeCurrency, currency } = useContext(LanguageContext);
  const ref = useOnclickOutside(() => {
    setIsOpen(false);
  });
  const { locale } = useIntl();

  const getLanguage = () => {
    if (locale === 'de') return <German />;
    if (locale === 'en') return <English />;
    if (locale === 'fr') return <French />;
    if (locale === 'da') return <Danish />;
    if (locale === 'nl') return <Dutch />;
  };

  return (
    <div className="hidden lg:block font-medium relative">
      <div className="flex items-center" onClick={() => setIsOpen(!isOpen)}>
        {getLanguage()}
        <span className="ml-1">{` / ${currency}`}</span>
      </div>
      <div
        ref={ref}
        className={isOpen ? 'absolute top-10 right-0 bg-white border rounded py-4 px-6 flex w-72' : 'hidden'}>
        <div className="pr-5 flex-1">
          <div className="py-1 inline-flex items-center cursor-pointer" onClick={() => changeLanguage('de')}>
            <German />
          </div>
          <div className="py-1 flex items-center cursor-pointer" onClick={() => changeLanguage('nl')}>
            <ReactCountryFlag countryCode="NL" svg className="mr-1 block" />
            <span>Nederlands</span>
          </div>
          <div className="py-1 flex items-center cursor-pointer" onClick={() => changeLanguage('en')}>
            <ReactCountryFlag countryCode="GB" svg className="mr-1 block" />
            <span>English</span>
          </div>
          <div className="py-1 flex items-center cursor-pointer" onClick={() => changeLanguage('fr')}>
            <ReactCountryFlag countryCode="FR" svg className="mr-1 block" />
            <span>Français</span>
          </div>
          <div className="py-1 flex items-center cursor-pointer" onClick={() => changeLanguage('da')}>
            <ReactCountryFlag countryCode="DK" svg className="mr-1 block" />
            <span>Dansk</span>
          </div>
          {/* <div className="py-1 flex items-center cursor-pointer" onClick={() => changeLanguage('nb')}>
            <ReactCountryFlag countryCode="NO" svg className="mr-1 block" />
            <span>Norsk</span>
          </div> */}
        </div>
        <div className="pl-5 border-l flex-1">
          <div className="py-1 inline-flex items-center cursor-pointer w-full" onClick={() => changeCurrency('EUR')}>
            <ReactCountryFlag countryCode="EU" svg className="mr-1 block" />
            <span>EUR</span>
          </div>
          {/* <div className="py-1 inline-flex items-center cursor-pointer" onClick={() => changeCurrency('GBP')}>
            <ReactCountryFlag countryCode="GB" svg className="mr-1 block" />
            <span>GBP</span>
          </div> */}
          {/* <div className="py-1 inline-flex items-center cursor-pointer" onClick={() => changeCurrency('USD')}>
            <ReactCountryFlag countryCode="US" svg className="mr-1 block" />
            <span>USD</span>
          </div> */}
          <div className="py-1 inline-flex items-center cursor-pointer w-full" onClick={() => changeCurrency('DKK')}>
            <ReactCountryFlag countryCode="DK" svg className="mr-1 block" />
            <span>DKK</span>
          </div>
          {/* <div className="py-1 inline-flex items-center cursor-pointer" onClick={() => changeCurrency('NOK')}>
            <ReactCountryFlag countryCode="NO" svg className="mr-1 block" />
            <span>NOK</span>
          </div> */}
        </div>
      </div>
    </div>
  );
};
